import script from "./suspendLayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./suspendLayer.vue?vue&type=script&setup=true&lang=ts"

import "./suspendLayer.vue?vue&type=style&index=0&id=0c343f1e&lang=less&scoped=true"

import exportComponent from "/workspace/hzjt-cms-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c343f1e"]])

export default __exports__